import { render, staticRenderFns } from "./ConfirmationEmailWizardModal.vue?vue&type=template&id=1f90a1e6"
import script from "./ConfirmationEmailWizardModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationEmailWizardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports